import FormDatepicker from '../modules/form-datepicker';
$ = jQuery;

class StockHistorySection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.datepickers = this.root.querySelectorAll('[data-date-input]');
        this.datepickersInstances = [];

        return true;
    }

    init() {
        this.setDatepickers();
    }

    setDatepickers() {
        if (!this.datepickers) return;

        this.datepickers.forEach(item => {
            this.datepickersInstances.push(new FormDatepicker(item));
        });
    }
}

const sections = document.querySelectorAll('[data-stock-history]');
const initStockHistory = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new StockHistorySection(el);
    });
};

initStockHistory(sections);
